import { useGetUserOrganizations } from "@/queries/users/users.api";
import { useEffect, useState } from "react";

const useUserOrganizationCatalog = (filterActiveOnly = false) => {
  const { data, isLoading, isFetching } = useGetUserOrganizations();

  const [organization, setOrganization] = useState<
    {
      label: string;
      value: string;
      active: boolean;
    }[]
  >([]);

  useEffect(() => {
    const rows = Array.isArray(data?.data) ? data.data : [];
    const filtered = filterActiveOnly
      ? rows.filter((r: { activo?: boolean }) => r.activo !== false)
      : rows;
    setOrganization(
      filtered.map((r: { nombre: string; id: string; activo: boolean }) => {
        return {
          label: r.nombre,
          value: r.id,
          active: r.activo,
        };
      }),
    );
  }, [data, filterActiveOnly]);

  return {
    organization,
    isLoading,
    isFetching,
  };
};

export default useUserOrganizationCatalog;
